import styled from 'styled-components';

interface StyledProps {
  isFacelift?: boolean;
}

export const Container = styled.div<StyledProps>`
  width: 97%;
  margin: 1rem auto 5rem auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1.5rem auto 5rem auto;
    max-width: ${({ theme, isFacelift }) =>
      isFacelift ? '' : theme.breakpoints.laptopL};
  }
`;

export const ConstructionRegistrationBlock = styled.section<StyledProps>`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 0.25rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ isFacelift }) => (isFacelift ? '1rem 1rem 1rem 0' : '1rem')};
    margin-bottom: 1.5rem;
    max-width: ${({ theme, isFacelift }) =>
      isFacelift ? '' : theme.breakpoints.laptopL};
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-size: 1.125rem;
    font-weight: 700;
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;
  }
`;

export const ConstructionRegistrationBlockHeader = styled.header`
  margin-bottom: 1rem;

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-size: 1.125rem;
    font-weight: 700;
  }

  & > .sub-title {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  & > .sub-titleFacelift {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 1rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grayDark4};
  }

  & > .message {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-size: 0.875rem;
    font-weight: 700;
  }
`;
